import theme from '@/constants/theme';
import React, { InputHTMLAttributes, useId, useState } from 'react';
import FormLabel from '../FormLabel';
import ShowOrHidePasswordButton from './ShowOrHidePasswordButton';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  label?: string;
  helperText?: string;
  sx?: React.CSSProperties;
  containerSx?: React.CSSProperties;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, label, helperText, sx, containerSx, ...props }, ref) => {
    const inputId = useId();

    const [type, setType] = useState<HTMLInputElement['type']>(props.type ?? 'text');

    const InputComponent = (
      <input
        id={inputId}
        style={{
          height: 48,
          borderWidth: 1,
          borderRadius: 8,
          paddingLeft: 12,
          paddingRight: 12,
          color: theme.colors.text.body,
          backgroundColor: theme.colors.background.secondary,
          border: `1px solid ${theme.colors.border}`,
          maxWidth: '100%',
          ...sx,
          ...props.style,
        }}
        ref={ref}
        {...props}
        type={type}
      />
    );

    if (label) {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, ...containerSx }}>
          <FormLabel label={label} helperText={helperText} htmlFor={inputId} />
          <div style={{ display: 'flex', flexDirection: 'column', position: 'relative' }}>
            {InputComponent}
            {props.type === 'password' && <ShowOrHidePasswordButton type={type} setType={setType} />}
          </div>
        </div>
      );
    }

    return InputComponent;
  },
);

Input.displayName = 'Input';

export default Input;
